module.exports = __webpack_public_path__ + "static/media/bg-new2.4cff8162.jpg";